import { ConferenceTags as ConferenceTagsType } from 'types/models/Conference';
import Typography from '@components/atoms/Typography';
import SeoShare, { Props as ShareProps } from '@components/SeoShare';

import classes from './ConferenceTags.module.scss';

type Props = {
  tags?: ConferenceTagsType;
  shareData?: ShareProps;
};

const ConferenceTags = ({ tags, shareData }: Props) => (
  <div className={classes.tags}>
    {tags?.map(({ tag }) => (
      <Typography key={tag.id} className={classes.tag} variant="caption1" renderAs="div">
        {tag.name}
      </Typography>
    ))}
    {shareData && <SeoShare {...shareData} />}
  </div>
);

export default ConferenceTags;
